import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { CommonService } from "src/app/services/common/common.service";
import { environment } from "src/environment/environment";

@Component({
  selector: "app-complaints-view",
  templateUrl: "./complaints-view.component.html",
  styleUrls: ["./complaints-view.component.css"],
})
export class ComplaintsViewComponent {
  viewData1 = {
    selectedImage: [
      "https://yumpumapi.disctesting.in/uploads/restuarant/restuarantLogo/restaurant_logoImage58.jpeg",
      "https://yumpumapi.disctesting.in/uploads/restuarant/restuarantLogo/restaurant_logoImage58.jpeg",
    ],
  };
  viewData: any;
  complaintLogList: any;
  customer_id: any;
  // id: any;
  complaintAttachmentList: any;
  customerActionLogsId: any;

  fromDashboard:boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    private http: HttpClient
  ) {}

  async ngOnInit(): Promise<void> {

      //if came here from dashboard
      this.route.queryParams.subscribe(params => {
        this.fromDashboard = params['fromDashboard'] === 'true'; // Convert string to boolean
        console.log("From Dashboard:", this.fromDashboard);
      });
            
    let id = this.route.snapshot.paramMap.get("id");
    console.log("id into Complaint view===>", id);
    
    this.customerActionLogsId = localStorage.getItem("customerActionLogsId");
    const payload = {"complaintId":id,"customerActionLogsId":this.customerActionLogsId}
    await this.commonService
      .complainView(payload)
      .subscribe(
        (res: any) => {
          if (res.code == 1) {
            this.viewData = res.data;
            this.complaintLogList = res.complaintLogList;
            this.complaintAttachmentList = res.complaintAttachmentList;

            // Static URL for the image path
            const staticImageUrl = environment.imageUrl + "EmployeeTask/";

            //for new logic
            const primaryUrl = environment.imageUrl + "EmployeeTask/";
            const fallbackUrl = environment.pmsUrl + "EmployeeTask/";
            //for new logic end

            // Concatenate the static URL with each attachment
            if (this.complaintAttachmentList) {
              // this.complaintAttachmentList.forEach((attachment: any) => {
              //   attachment.attachmentUrl =
              //     staticImageUrl + attachment.attachment;
              // });


              //new
              this.complaintAttachmentList.forEach((attachment: any) => {
                const fileName = attachment.attachment;
        
                this.checkUrl(primaryUrl + fileName).then(found => {
                  if (found) {
                    attachment.attachmentUrl = primaryUrl + fileName;
                  } else {
                    attachment.attachmentUrl = fallbackUrl + fileName;
                    // this.checkUrl(fallbackUrl + fileName).then(fallbackFound => {
                    //   attachment.attachmentUrl = fallbackFound ? fallbackUrl + fileName : '';
                    // });
                  }
                });
              });
              //new end
            }
          } else {
            // Handle other response codes or errors here
          }
        },
        (error: any) => {
          console.error("Error:", error);
        }
      );
  }
// Utility to check if URL exists
  async checkUrl(url: string): Promise<boolean> {
  try {
    const res:any = await this.http.head(url, { observe: 'response' }).toPromise();
    return res.status === 200;
  } catch {
    return false;
  }
}
  goBack() {
    if(this.fromDashboard){
      this.router.navigate(["/dash"]);        
  } else {
    this.router.navigate(["/ComplaintsList"]);
  }
  }

  isPdfAttachment(attachment: any): boolean {
    // Check if the attachment URL ends with a PDF file extension, e.g., '.pdf'
    // console.log(
    //   "attachment.attachmentUrl.toLowerCase().endsWith('.pdf')",
    //   attachment.attachmentUrl.toLowerCase().endsWith(".pdf")
    // );

    return attachment.attachmentUrl.toLowerCase().endsWith(".pdf");
  }

  getImagePath(fileName: string): string {
    const extension = this.getFileExtension(fileName);
    // console.log("extension--->", extension);

    if (extension) {
      return `assets/images/icon/${extension}.png`;
    }
    return "assets/images/icon/documents.png"; // Use a default image for unknown extensions
  }
  getFileExtension(fileName: string): string {
    const parts = fileName.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1].toLowerCase();
    }
    return ""; // Return an empty string if there's no extension
  }
}
